import React, { FC } from "react";
import styles from "../../../styles/B2C/OptionGrid.module.scss";

interface OptionGridProps {
  options: string[];
  selected: string[];
  onSelect: (value: string) => void;
  multiSelect?: boolean;
}

const OptionGrid: FC<OptionGridProps> = ({
  options,
  selected,
  onSelect,
  multiSelect = true,
}) => {
  return (
    <div className={styles.optionGrid}>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          title={option}
          className={`${styles.optionItem} ${selected.includes(option) ? styles.selected : ""}`}
          onClick={() => onSelect(option)}
        >
          <span className={styles.optionLabel}>{option}</span>
        </button>
      ))}
    </div>
  );
};

export default OptionGrid;
